/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/dot-notation */
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Tree } from '../models/tree.model';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class TreeResolve  {

    treeActivated = false;

    constructor() { }

    resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<Tree> /*Observable<unknown>|Promise<unknown>|unknown*/ {
        if (!this.treeActivated) {
            this.treeActivated = true;
        }
        return route.data['tree'];
        //return new Observable(Tree());
    }
}
